module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/move-map-modal/move-map-modal.component.css
// module id = ./src/app/widgets/move-map-modal/move-map-modal.component.css
// module chunks = main